// Shared in-content ("in-read") ad placement for the article detail view.
// Inserts the in-read ad box before a content element inside the article body,
// skipping non-body regions (tables, social embeds, iframes, creator profile)
// so the ad never lands inside an embed/table/profile.
// Used by both the mobile and desktop articleDetailView packs (TRILL-7123).

// Regions the in-read ad must never be inserted into. Covers SNS embeds in both
// states: blockquote (before the embed script runs) and iframe (after Threads/
// YouTube/Facebook transform or render the embed). The selectors mirror the
// embed taxonomy in lib/trill_description/lib/dom_helper.rb.
export const INREAD_EXCLUDED_SELECTOR = [
  'table',
  'iframe',
  'figure.trill-html-iframe-embed',
  'blockquote.instagram-media',
  'blockquote.twitter-tweet',
  'blockquote.tiktok-embed',
  'blockquote.text-post-media',
  'blockquote.reddit-card',
  'blockquote.reddit-embed-bq',
  '#fb-root',
  '.fb-post',
  '.fb-video',
].join(',');

export function insertInreadAd(container, adHtml) {
  if (!container) return;

  const root = container.querySelector('.trill-description') || container;

  // Nth element (0-based) of `tag` within the body, ignoring elements that live
  // inside an excluded region. Counting only body elements keeps the "Nth
  // paragraph" semantics aligned with the real article text.
  const pick = (tag, index) => Array.prototype.filter.call(
    root.getElementsByTagName(tag),
    (el) => !el.closest(INREAD_EXCLUDED_SELECTOR),
  )[index];

  // Same element priority/order as the original addGAM() logic (TRILL-7123).
  const target = pick('h3', 1)
    || pick('h4', 3)
    || pick('h5', 3)
    || pick('h4', 2)
    || pick('p', 9)
    || pick('figure', 4)
    || pick('p', 6)
    || pick('p', 4)
    || pick('figure', 3)
    || pick('p', 2)
    || pick('p', 1);

  if (target) target.insertAdjacentHTML('beforebegin', adHtml);
}
